/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResourceTypeValueDto
 */
export interface ResourceTypeValueDto {
    /**
     * The type.
     * @type {string}
     * @memberof ResourceTypeValueDto
     */
    type: ResourceTypeValueDtoTypeEnum;
    /**
     * True, if required.
     * @type {boolean}
     * @memberof ResourceTypeValueDto
     */
    required: boolean | null;
    /**
     * The description of the value.
     * @type {string}
     * @memberof ResourceTypeValueDto
     */
    description: string | null;
    /**
     * The minimum length.
     * @type {number}
     * @memberof ResourceTypeValueDto
     */
    minLength: number | null;
    /**
     * The maximum length.
     * @type {number}
     * @memberof ResourceTypeValueDto
     */
    maxLength: number | null;
    /**
     * The enum values.
     * @type {Array<string>}
     * @memberof ResourceTypeValueDto
     */
    allowedValues: Array<string> | null;
}


/**
 * @export
 */
export const ResourceTypeValueDtoTypeEnum = {
    Boolean: 'boolean',
    Number: 'number',
    String: 'string'
} as const;
export type ResourceTypeValueDtoTypeEnum = typeof ResourceTypeValueDtoTypeEnum[keyof typeof ResourceTypeValueDtoTypeEnum];


/**
 * Check if a given object implements the ResourceTypeValueDto interface.
 */
export function instanceOfResourceTypeValueDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "required" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "minLength" in value;
    isInstance = isInstance && "maxLength" in value;
    isInstance = isInstance && "allowedValues" in value;

    return isInstance;
}

export function ResourceTypeValueDtoFromJSON(json: any): ResourceTypeValueDto {
    return ResourceTypeValueDtoFromJSONTyped(json, false);
}

export function ResourceTypeValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceTypeValueDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'required': json['required'],
        'description': json['description'],
        'minLength': json['minLength'],
        'maxLength': json['maxLength'],
        'allowedValues': json['allowedValues'],
    };
}

export function ResourceTypeValueDtoToJSON(value?: ResourceTypeValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'required': value.required,
        'description': value.description,
        'minLength': value.minLength,
        'maxLength': value.maxLength,
        'allowedValues': value.allowedValues,
    };
}

